export const isCustomDisplayTextLabelPart = (part) => {
    return typeof part === 'object';
};
//# sourceMappingURL=display-text-label.js.map